import { FC } from 'react';

import JobseekerSearchBar from './JobseekerSearchBar';
import JobseekerHomeSearch from './JobseekerHomeSearch';

export enum SearchType {
  DEFAULT,
  NO_AUTH_JOBSEEKER,
  NO_AUTH_HOME,
}

export interface SearchProps {
  searchType?: SearchType;
}

export const Search: FC<SearchProps> = ({
  searchType = SearchType.NO_AUTH_JOBSEEKER,
}) => {
  switch (searchType) {
    case SearchType.NO_AUTH_JOBSEEKER:
      return <JobseekerSearchBar />;
    case SearchType.NO_AUTH_HOME:
      return <JobseekerHomeSearch />;
    default:
      return null;
  }
};

export default Search;
